// import {useState, useEffect, useRef} from "react";
// import SectionTitle from "../SectionTitles/SectionTitle";
import SectionTitleTwo from "../SectionTitles/SectionTitleTwo";
// import Tilt from 'react-parallax-tilt';
// import Parallax from 'parallax-js';
// import {Link} from "react-router-dom";

const HomeAbout = () => {
  // const [scale] = useState(1.04);
  // const sceneEl = useRef(null);

  // useEffect(() => {
  //     const parallaxInstance = new Parallax(sceneEl.current, {
  //     relativeInput: true,
  //     })

  //     parallaxInstance.enable();

  //     return () => parallaxInstance.disable();

  // }, [])
  return (
    <div className="section section-padding-t90 section-padding-t50-b0">
      <div className="container">
        {/* <SectionTitle title="Introduction" /> */}

        <div className="row">
          {/* <div className="col-xl-7 col-lg-6 col-12" data-aos="fade-up">
                        <div className="about-image-area">
                            <div className="about-image">
                                <Tilt scale={scale} transitionSpeed={4000}>
                                    <img src={process.env.PUBLIC_URL + "images/about/home-one-about/home_agency_about_1.jpg"} alt="" />
                                </Tilt>
                            </div>
                        
                            <div className="about-image">
                                <Tilt scale={scale} transitionSpeed={4000}>
                                    <img src={process.env.PUBLIC_URL + "images/about/home-one-about/home_agency_about_2.jpg"} alt="" />
                                </Tilt>
                            </div>
                            <div className="shape shape-1" id="scene" ref={sceneEl}>
                                <span data-depth="1"><img src={process.env.PUBLIC_URL + "images/shape-animation/about-shape-1.png"} alt="" /></span>
                            </div>

                        </div>
                    </div> */}

          <div
            className="col-xl-6 col-lg-6 col-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-content-area">
              <SectionTitleTwo
                // subTitle="Every day brings new challenges"
                title="Overview of Data Mining and Big Data (DMBD)"
              />
              <div className="intro">
                <p className="home-p text-justify">
                  The Ninth International Conference on Data Mining and Big Data (DMBD&apos; 2024) serves as an international forum for researchers and practitioners to exchange latest advantages in theories, algorithms, models,
                  and applications of data mining and big data as well as artificial intelligence techniques. 
                  Data mining refers to the activity of going through big data sets to look for relevant or pertinent information Big data contains huge amount of data and information and is worth researching in depth.
                </p>
                <p className="home-p text-justify">
                  DMBD&apos;2024 is the
                  ninth event after the preceding Guangzhou, Belgrade, Chiang Mai, Shanghai, Fukuoka, Bali, Beijing and Sanya events
                  where more than hundreds of delegates from all over the world to attend and share their
                  latest achievements, innovative ideas, marvelous designs and excel implementations.
                </p>

                {/* <p className="home-p text-justify">
                  This year&apos;s main theme is <strong>FinTech</strong>, and we will pay special attention to technologies
                  and applications in
                  the
                  area of FinTech.
                </p> */}
                <p className="home-p text-justify">
                  DMBD&apos;2024 will be held during December 13th-16th, 2024 in Ho Chi Minh City, Vietnam.
                  Ho Chi Minh City, formerly known as Saigon, is the largest city in Vietnam by population. Located in the southern part of the country, it serves as a vital economic, cultural, and educational hub. The city is renowned for its vibrant street life, bustling markets, and a unique blend of architectural styles that reflect its historical layers, ranging from French colonial buildings to modern skyscrapers.                </p>
              </div>

              {/* <Link className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" to={process.env.PUBLIC_URL + "/about"}>Learn More</Link> */}
            </div>
          </div>

          <div
            className="col-xl-6 col-lg-6 col-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-content-area">
              {/* <SectionTitleTwo 
                                // subTitle="Every day brings new challenges"
                                title="International Conference on Swarm Intelligence"
                            /> */}

              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>

              <p className="home-p text-justify">
              The city&apos;s culinary scene is a paradise for food lovers, featuring a wide array of delicious Vietnamese dishes such as pho, banh mi, and fresh spring rolls. Whether you&apos;re exploring the narrow alleys of Chinatown or the trendy cafes and shops of District 1, Ho Chi Minh City offers a dynamic and captivating experience for all visitors.              </p>
              <p className="home-p text-justify">
                Papers presented at DMBD&apos;2024 will be published Springer-Nature in Communications in Computer and
                Information Science (CCIS) (indexed by EI, ISTP, DBLP, SCOPUS, ISI, Web of Science, etc.) The downloads
                of our meeting&apos;s proceedings reach the top 25% of all publications of Springer-Nature. Some high-quality
                papers will be selected for SCI-indexed Transaction (including IEEE Trans, Swarm and Evolutionary
                Optimization, etc.) and Journal Special Issues, such as:
                <ul className="home-p">
                  <li>
                    International Journal of Intelligence System (IF=8.71)
                  </li>
                  <li>
                    Electronics (IF=2.690)
                  </li>
                  <li>
                    Multimedia Tools and applications (IF=2.58)
                  </li>
                  <li>
                    Machine Learning with Applications (IF=8.67)
                  </li>
                  <li>
                    IASEI Transactions on Swarm Intelligence
                  </li>
                  <li>
                    ...
                  </li>
                </ul>
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;
